export default __webpack_public_path__ + "static/media/warning--y-roads--g2.8994d575.png";